
export default {
  name: 'NuxtError',
  props: {
    error: {
      type: Object,

      default: () => {},
    },
  },
}
